import { Container } from '@pixi/react';
import { useEffect, useRef } from 'react';
import { Spine } from '../../../../../components';

export const JackpotStage: React.FC = () => {
  const ref = useRef<any>();

  useEffect(() => {
    if (ref.current) {
      const spine: Spine = new Spine({ key: 'jackpotBackGroundStage' });
      ref.current.addChild(spine);
      spine.play('idle', true);
    }
  }, []);

  return <Container ref={ref} {...({ name: 'JackpotBackGroundStage' } as any)} />;
};
